import FontSize from "./FontSize.svelte"
import { openBottomPopup } from "./bottomPopup.module"

export function openFontSizeEditor() {
    openBottomPopup(FontSize)
}
